"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgeryDrugDosageType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryDrugDosageType_Factory = /** @class */ (function () {
    function SurgeryDrugDosageType_Factory() {
    }
    SurgeryDrugDosageType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    SurgeryDrugDosageType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return SurgeryDrugDosageType_Factory;
}());
exports.SurgeryDrugDosageType_Factory = SurgeryDrugDosageType_Factory;
